import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
    standalone: false
})
export class ToasterComponent {

  @Input() title          : string;
  @Output() closeToaster  : EventEmitter<any> = new EventEmitter<any>();
  delayMilliseconds       : number;
  showsToast              : boolean = true;

  constructor() {
    this.startCloseTimer();
  }

  startCloseTimer() {
    const delayMilliseconds = 3000;
    setTimeout(() => {
     this.close();
    }, delayMilliseconds);
  }

  close() {
    this.showsToast = false;
    this.closeToaster.emit(false);
  }

}
